var BASWebServices;
(function (BASWebServices) {
    var PrivacyPolicyController = (function () {
        function PrivacyPolicyController($scope, ngDialog) {
            this.$scope = $scope;
            this.ngDialog = ngDialog;
            this.$scope.ppc = this;
        }
        PrivacyPolicyController.prototype.withdrawConsent = function () {
            window.localStorage.removeItem('basWebServices.consentToClarinStats');
            this.ngDialog.open({
                template: 'views/partials/dialogs/consentWithdrawn.html',
                className: 'ngdialog-theme-default',
                closeByEscape: false,
                showClose: false,
                closeByDocument: false,
                scope: this.$scope,
                controller: ['$scope', '$window', function ($scope, $window) {
                        $scope.reload = function () {
                            $window.location.reload();
                        };
                    }]
            });
        };
        return PrivacyPolicyController;
    }());
    BASWebServices.PrivacyPolicyController = PrivacyPolicyController;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=PrivacyPolicyController.js.map